document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const isOpen = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('menu-open', isOpen);
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      const mainImage = gallery && gallery.querySelector('[data-gallery-main]');
      if (!mainImage) return;
      mainImage.src = button.dataset.imageSrc;
      mainImage.srcset = button.dataset.imageSrcset || '';
      mainImage.alt = button.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const root = select.closest('[data-product-root]');
      const option = select.options[select.selectedIndex];
      if (!root || !option) return;
      const price = root.querySelector('[data-product-price]');
      const submit = root.querySelector('[data-add-to-cart]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableText : submit.dataset.soldOutText;
      }
    });
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const change = button.dataset.quantityAction === 'increase' ? 1 : -1;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-filters]').forEach((filters) => {
    const target = document.querySelector(filters.dataset.target);
    if (!target) return;

    const buttons = filters.querySelectorAll('[data-product-filter]');
    const cards = target.querySelectorAll('[data-filter-card]');
    const emptyState = target.querySelector('[data-filter-empty]');
    const params = new URLSearchParams(window.location.search);
    let storedFilter = '';
    try {
      storedFilter = window.sessionStorage.getItem('pawlynta-selected-filter') || '';
      window.sessionStorage.removeItem('pawlynta-selected-filter');
    } catch (error) {}
    const initialFilter = params.get('category') || storedFilter || 'all';

    const applyFilter = (filter) => {
      let visibleCount = 0;

      buttons.forEach((button) => {
        const isActive = button.dataset.productFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      cards.forEach((card) => {
        const categories = (card.dataset.categories || 'all').split(/\s+/);
        const isVisible = filter === 'all' || categories.includes(filter);
        card.hidden = !isVisible;
        card.classList.toggle('is-hidden', !isVisible);
        if (isVisible) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount !== 0;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.dataset.productFilter || 'all');
      });
    });

    const hasInitialFilter = Array.from(buttons).some((button) => button.dataset.productFilter === initialFilter);
    applyFilter(hasInitialFilter ? initialFilter : 'all');
  });

  document.querySelectorAll('[data-filter-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const selectedFilter = link.dataset.filterLink;
      try {
        window.sessionStorage.setItem('pawlynta-selected-filter', selectedFilter);
      } catch (error) {}

      const href = link.getAttribute('href') || '';
      if (href.startsWith('#')) {
        const filterButton = document.querySelector(`[data-product-filter="${selectedFilter}"]`);
        if (filterButton) {
          window.setTimeout(() => filterButton.click(), 40);
        }
      }
    });
  });

  const newsletterPopup = document.querySelector('[data-newsletter-popup]');
  if (newsletterPopup) {
    const closeButtons = newsletterPopup.querySelectorAll('[data-newsletter-popup-close]');
    const form = newsletterPopup.querySelector('form');
    const storageKey = newsletterPopup.dataset.storageKey || 'pawlynta-newsletter-popup';
    const frequencyDays = Number(newsletterPopup.dataset.frequencyDays || 7);
    const delay = Number(newsletterPopup.dataset.delay || 1000);
    const scrollDepth = Number(newsletterPopup.dataset.scrollDepth || 25);
    const hasSuccessMessage = Boolean(newsletterPopup.querySelector('[role="status"]'));
    const hasErrorMessage = Boolean(newsletterPopup.querySelector('[role="alert"]'));
    const hasFormMessage = hasSuccessMessage || hasErrorMessage;
    let openTimer;
    let didQueueOpen = false;

    const getDismissedAt = () => {
      try {
        return Number(window.localStorage.getItem(storageKey) || 0);
      } catch (error) {
        return 0;
      }
    };

    const markDismissed = () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        // localStorage can be unavailable in private browsing; the popup still works.
      }
    };

    const shouldShowPopup = () => {
      if (hasFormMessage) return true;
      const dismissedAt = getDismissedAt();
      if (!dismissedAt) return true;
      return Date.now() - dismissedAt > frequencyDays * 24 * 60 * 60 * 1000;
    };

    const openPopup = () => {
      if (!shouldShowPopup()) return;
      newsletterPopup.classList.add('is-open');
      document.body.classList.add('newsletter-popup-open');
      const focusTarget = newsletterPopup.querySelector('input[type="email"]') || newsletterPopup.querySelector('.newsletter-popup__close');
      window.setTimeout(() => focusTarget && focusTarget.focus({ preventScroll: true }), 120);
    };

    const closePopup = (shouldMarkDismissed = true) => {
      newsletterPopup.classList.remove('is-open');
      document.body.classList.remove('newsletter-popup-open');
      if (shouldMarkDismissed) markDismissed();
      if (openTimer) window.clearTimeout(openTimer);
      window.setTimeout(() => newsletterPopup.classList.remove('is-success'), 260);
    };

    const showThankYou = () => {
      newsletterPopup.classList.add('is-success');
      markDismissed();
      const submitButton = form && form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;
    };

    const queuePopup = () => {
      if (didQueueOpen || !shouldShowPopup()) return;
      didQueueOpen = true;
      window.removeEventListener('scroll', handleScroll);
      openTimer = window.setTimeout(openPopup, delay);
    };

    function handleScroll() {
      const scrollableDistance = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const scrolledPercent = (window.scrollY / scrollableDistance) * 100;
      if (window.scrollY > 260 || scrolledPercent >= scrollDepth) queuePopup();
    }

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && newsletterPopup.classList.contains('is-open')) closePopup();
    });
    if (form) {
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;

        const action = form.getAttribute('action') || '';
        const isLocalPreview = action === '#' || action === window.location.href || form.dataset.previewForm === 'true';
        if (isLocalPreview) {
          event.preventDefault();
          showThankYou();
          window.setTimeout(() => closePopup(false), 1600);
          return;
        }

        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.textContent = submitButton.dataset.loadingText || 'Joining...';
        }
      });
    }

    if (hasSuccessMessage) {
      openPopup();
      showThankYou();
      window.setTimeout(() => closePopup(false), 1800);
    } else if (hasFormMessage) {
      openPopup();
    } else if (shouldShowPopup()) {
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    }
  }
});
